// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Container, Box, Flex, Text, Button } from 'yard-utilities/components'

// Images
import Background from '@images/v25/backgrounds/homepage/background.png'

// Styles
import styles from './HomepageWrapper.module.sass'

// Data
import data from '@data/v25/ft1/media.json'

interface HomepageWrapperProps {
  redirectURL: string
}

const HomepageWrapper = ({ redirectURL }: HomepageWrapperProps) => {
  return (
    <section className={styles.section}>
      <Box padding={{ sm: [48, 0, 24] }} className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          <Image
            src={Background}
            fill
            sizes="(min-width: 1120px) 3000px, 800px"
            placeholder="blur"
            priority
            alt="Sandy Beach"
          />
        </div>

        <Container>
          <Box padding={{ sm: [0, 0] }}>
            <Text
              tagName="h1"
              variant="title-1"
              align="center"
              textColor="white"
              spacing={{ sm: 16 }}
              transform="capitalize"
            >
              Best flight deals delivered automatically
            </Text>
            <Text
              tagName="p"
              variant="body-2"
              align="center"
              textColor="white"
              spacing={{ sm: 48 }}
              className={styles.description}
            >
              Straight to your inbox
            </Text>
          </Box>
          <Flex fullWidth justifyContent="center">
            <Button href={redirectURL} variant="yellow-sm-shadow" as={Link}>
              Start now
            </Button>
          </Flex>
        </Container>
        <Container>
          <Text
            tagName="h4"
            variant="title-3"
            align="center"
            textColor="white"
            spacing={{ sm: 24 }}
          >
            As featured in:
          </Text>
          <Flex
            rowGap={{ sm: 24 }}
            columnGap={{ sm: 32 }}
            wrap
            center
            id="recent-deals-anchor"
          >
            {data.map((item) => (
              <Image
                key={item.id}
                src={item.img}
                height={24}
                width={item.width}
                alt={item.alt}
              />
            ))}
          </Flex>
        </Container>
      </Box>
    </section>
  )
}

export default HomepageWrapper
